<template>
  <div class="home page-home" :style="cssVars">
    <!-- banner pc端/mob端 -->
    <div class="row">
      <div class="banner pc">
        <div class="banner_mid">
          <div class="banner_top">
            <div class="introduce">
              <p>Make professional<br>Discovery</p>
            </div>
            <!-- 时间、地点、按钮 - main.js -->
            <div class="meetingdata">
              <span class="glyphicon glyphicon-time"></span>
              <span class="trueData">{{meeting.time}}</span>
              <span class="glyphicon glyphicon-map-marker"></span>
              <!-- <span class="truePlace">
                {{global.config[sid].title}}<slot v-if="global.config[sid].trueplace&&global.config[sid].trueplace!=''">-{{global.config[sid].trueplace}}</slot>
              </span> -->
              <span class="truePlace">
                {{(meeting.address!=''&&meeting.address!='未定') ? meeting.address : global.config[sid]['title']}}{{(global.config[sid].trueplace&&global.config[sid].trueplace!='')?('-'+global.config[sid].trueplace):''}}
              </span>
            </div>
            <div class="row">
              <a @click.prevent="toNext('order')" class="turn_link_order turn_link reallink" v-if="global.area_id && global.config[global.area_id] && global.year.includes(thisYear)">
                <span class="zd_order">MPD{{global.config[sid]['title']}}站报名中</span>
                <span class="discount">团队报名最低6折优惠！</span>
              </a>
              <slot v-for="(item,index) in review">
                <a v-if="sid != item.id" @click="changSid(parseInt(item.id))" :key="'home_zd_'+index" class="zandian">
                  <p>第{{global.config[item.id]['jieshu']}}届MPD<br>
                  {{global.config[item.id]['title']}}站 报名中</p>
                </a>
              </slot>
              <!-- <a @click="changSid(2762)" class="zandian zd_dl">
                <p>第51届MPD<br />大连站</p>
              </a>
              <a @click="changSid(2940)" class="zandian zd_gz">
                <p>第52届MPD<br />广州站</p>
              </a>
              <a @click="changSid(2942)" class="zandian zd_cd">
                <p>第53届MPD<br />成都站</p>
              </a> -->
            </div>
          </div>
        </div>
        <div class="banner_bottom">
          <div class="banner_bottom_con">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <p class="banner_p2"><span>3</span></p>
                <p class="banner_p3">
                  180分钟实践沙盘课程，还原真实工作场景，交付真实的工作技能
                  <span>小时微型课程</span>
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <p class="banner_p2"><span>{{ global.config[global.area_id].base&&global.config[global.area_id].base.teachers || '25' }}</span></p>
                <p class="banner_p3">
                  面对面传授实战经验，带领学员进行沙盘演练中巩固知识点
                  <span>位一线客席教练</span>
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div>
                <p class="banner_p2"><span>500</span></p>
                <p class="banner_p3">
                  互联网、金融、通讯等行业的技术产品负责人共同学习、分组实践
                  <span>+参会同行</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="banner_hx"></div> -->
      </div>
      <div class="banner_wap mob">
        <div class="introduce row">
         <div class="tubiao">
           <img src="../../static/images/banner_img01.png" />
           <span>{{meeting.time}}</span>
         </div>
         <div class="tubiao">
           <img src="../../static/images/banner_img02.png" />
           <span v-if="meeting.address.indexOf('直播')!=-1">{{meeting.address}}</span>
           <span v-else>中国.{{global.config[sid].title}}</span>
         </div>
         </div>
         <p class="wap_bannerp1">
           MPD工作坊是一个围绕岗位角色发展的实践课堂，按照软件研发中心的岗位职能划分，以产品经理、团队经理、 架构师、开发经理、测试经理作为五个分会场命名，以促进角色的共鸣思考、深度探讨、相互交流。
         </p>
         <div class="wap_banner_btn">
           <a @click.prevent="toNext('order')" class="turn_link_order turn_link reallink" v-if="global.area_id && global.config[global.area_id] && global.year.includes(thisYear)">
             <span class="zd_order">MPD{{global.config[sid].title}}站报名中</span>
           </a>
           <slot v-for="(item,index) in review">
             <a v-if="sid != item.id" @click="changSid(parseInt(item.id))" :key="'home_zd_mob_'+index" class="turn_link_order">
               <span>第{{global.config[item.id]['jieshu']}}届MPD{{global.config[item.id].title}}站报名中</span>
             </a>
           </slot>
           <!-- <a @click="changSid(2691)" class="turn_link_order zd_sh">
             <span>MPD上海站</span>
           </a>
           <a @click="changSid(2721)" class="turn_link_order zd_bj">
             <span>MPD北京站</span>
           </a>
           <a @click="changSid(2762)" class="turn_link_order zd_dl">
             <span>MPD大连站</span>
           </a> -->
         </div>
         <!-- <div class="wap_banner_bottom">
           <img src="../../static/images/wap_bottom.png" width="100%" />
         </div> -->
      </div>
    </div>
    <!-- 五大方向 pc端/mob端 -->
    <div class="row">
      <div class="direct ">
        <div class="all">
          <h1>五大方向</h1>
          <p class="pc">
            MPD工作坊由专家客座教练携一线实践案例与学员深度剖析，结合案例梳理，打破研发过程<br />中发生的种种窘境，实践案例由五大议题方向构成。
          </p>
          <p class="mob">
            MPD工作坊由专家客座教练携一线实践案例与学员<br />深度剖析，结合案例梳理，打破研发过程中<br />发生的种种窘境，实践案例由五大议题方向构成。
          </p>
          <div>
            <ul>
              <li v-for="(item, index) in direct" :key="'direct_' + index">
                <div>
                  <img :src="item.img" alt="" />
                </div>
                <h1>{{ item.title }}</h1>
                <p>{{ item.des }}</p>
              </li>
              <li class="clearfloat"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 国内外技术专家 pc端/mob端 -->
    <div class="row">
      <div class="person row pc">
        <div class="all">
          <h1>跟谁学习</h1>
          <p class="person_p1">超过600位一线教练进行传授，与优秀比肩，在不知不觉中提升！</p>
          <ul>
            <li v-for="(item,index) in lecturers" :key="'lecturer'+index">
              <a @click.prevent="toNext('teacher',item.id)">
                <div class="img">
                  <div>
                    <img :src="item.thumbs?getThumbs(item.thumbs):'../../static/images/def.jpg'"/>
                  </div>
                </div>
                <div class="text">
                  <span>{{ (item.penName != "" && item.penName != null ) ? item.penName : item.name }}</span>
                  <p class="person_p2">{{ item.company }}</p>
                  <p>{{ item.position }}</p>
                </div>
              </a>
            </li>
          </ul>
          <div class="text-center">
            <a @click.prevent="toNext('experts')" class="more turn_link">更多教练</a>
          </div>
        </div>
      </div>
      <div class="wap_person row mob">
        <h1>跟谁学习</h1>
        <p class="person_p1">超过600位一线教练进行传授，<br>与优秀比肩，在不知不觉中提升！</p>
        <ul class="row">
          <li v-for="(item,index) in lecturers" :key="'lecturer'+index">
            <a @click.prevent="toNext('teacher',item.id)">
              <div class="img">
                <div>
                  <img Width="100" height="100" :src="item.thumbs?getThumbs(item.thumbs):'../../static/images/def.jpg'"/>
                </div>
              </div>
              <div class="text">
                <span>{{ (item.penName != "" && item.penName != null ) ? item.penName : item.name }}</span><br>
                <span class="sp2">{{ item.company }}<br>{{ item.position }}</span>
              </div>
            </a>
          </li>
        </ul>
        <div class="text-center cha">
          <a @click.prevent="toNext('experts')" class="more turn_link">更多教练</a>
        </div>
      </div>
    </div>
    <!-- 精选案例(沙盘工作坊) pc端/mob端 -->
    <div class="anli row">
      <div class="all ">
        <h1>
          沙盘工作坊
          <img v-if="courses && courses.length>casesRenderLength['pc']" class="pc refresh" @click="refreshCases" src="../assets/img/refresh.png" alt="">
          <img v-if="courses && courses.length>casesRenderLength['mob']" class="mob refresh" @click="refreshCases" src="../assets/img/refresh.png" alt="">
        </h1>
        <p>汇聚行业领先技术议题，一线大牛深度解析</p>
        <ul class="row">
          <li v-for="(item,index) in cases" :key="'course'+ index" class="col-lg-4 col-md-4 col-sm-4">
           <a @click.prevent="toNext('course',item.courseid)">
            <div class="wenzi">
             <h2>{{item.title}}</h2> <hr style="border-top: 1px solid #d7d7d7;">
             <p>{{item.desc}}</p>
            </div>
           </a>
          </li>
        </ul>
        <div class="text-center cha">
          <a @click.prevent="toNext('example')" class="more turn_link">更多课程</a>
        </div>
      </div>
    </div>
    <!-- 回顾 pc端/mob端 -->
    <div class="row">
      <div class="huigu row pc">
        <div class="all">
          <div>
            <h1>往期回顾</h1>
          </div>
          <div class="img">
            <time-line :sid="sid" :timeList="timeList"></time-line>
          </div>
        </div>
      </div>
      <div class="wap_huigu row mob">
        <div class="all">
          <div>
            <h1>往期回顾</h1>
          </div>
          <div class="img">
            <time-line :sid="sid" :timeList="timeList"></time-line>
          </div>
        </div>
      </div>
    </div>
    <!-- 收获 pc端/mob端 -->
    <div class="row">
      <div class="shouhuo_all row pc">
        <div class="shouhuo">
          <h1>客户证言</h1>
          <p>不断提升服务水平，聆听行业最真实的声音</p>
          <div class="gundong_img">
            <ul class="row">
              <li v-for="(item,index) in shouhuo_text" :key="'shouhuo_'+ index">
                <div class="text">
                  <div>
                    <p>{{item.text}}</p>
                    <p class="ri">——{{item.name}}</p>
                    <p class="ri">{{item.position}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="wap_shouhuo row mob">
        <div class="col-sm-12 col-xs-12">
          <h1>客户证言</h1>
          <p>不断提升服务水平，聆听行业最真实的声音</p>
          <div class="wenzi">
            <div class="slogan">
              <div id="carousel-example-generic" class="carousel slide" data-ride="carousel" >
                <ol class="carousel-indicators">
                  <li
                    v-for="(item,index) in shouhuo_text" :key="'shouhuo_li_'+ index"
                    data-target="#carousel-example-generic"
                    :data-slide-to="index"
                    :class="index==0?'active':''"
                  ></li>
                </ol>
                <div class="carousel-inner" role="listbox">
                  <div :class="index==0?'item active text':'item text'" v-for="(item,index) in shouhuo_text" :key="'shouhuo_'+ index">
                    <div>
                      <p>{{item.text}}</p>
                      <p class="text-right">——{{item.name}}<br>{{item.position}}</p>
                    </div>
                  </div>
                  <!-- <div class="item active text">
                    <div>
                      <p>
                        每次参加MPD都是一次快速提升的经历，通过学习别人的经验可以让我们自己的开发少走弯路。
                      </p>
                      <p class="text-right">——Jessica<br />花旗银行项目经理</p>
                    </div>
                  </div>
                  <div class="item text">
                    <div>
                      <p>
                        今年的MPD引入了视觉引导系统，在听完课后，把视觉引导图拍走，回家可以根据引导图迅速回忆起老师讲的东西
                      </p>
                      <h6 class="text-right">—中兴通信系统架构师</h6>
                    </div>
                  </div>
                  <div class="item text">
                    <div>
                      <p>
                        参加MPD最大的好处就是能让团队的成员串场听工作范围以外的一些分享和案例，这对培养全面素质的技术管理者很有好处
                      </p>
                      <h6 class="text-right">—Hp测试经理</h6>
                    </div>
                  </div>
                  <div class="item text">
                    <div>
                      <p>
                        每年派人参加MPD就是因为可以在这里动手实践一些东西，我觉得这比单纯的技术分享对别人的启发大
                      </p>
                      <h6 class="text-right">—一号店产品负责人</h6>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 赞助 pc端/mob端 -->
    <div class="row">
      <div class="his">
        <div class="history_com row pc">
          <h1>媒体社区支持</h1>
          <p>一线互联网科技媒体、社区助力MPD品牌塑造</p>
          <ul class="zanzhu_five">
            <li v-for="(item,index) in sponsors" :key="'sponsor_'+index">
              <div>
                <a :href="item.content" target="_blank">
                  <img :src="item.file" width="100%"/>
                </a>
              </div>
            </li>
            <li class="clearfloat"></li>
          </ul>
          <div class="text-center cha">
            <a @click.prevent="toNext('sponsor')" class="more turn_link">更多媒体</a>
          </div>
        </div>
      </div>
      <div class="wap_history_com row mob" >
        <h1>媒体社区支持</h1>
        <p>一线互联网科技媒体、社区助力MPD品牌塑造</p>
        <ul class="wap_zhanzhu_five">
          <li class="col-sm-6 col-xs-6" v-for="(item,index) in sponsors" :key="'sponsor_'+index">
            <div>
              <a :href="item.content" target="_blank">
                <img :src="item.file" width="100%"/>
              </a>
            </div>
          </li>
          <li class="clearfloat"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable space-unary-ops */
/* eslint-disable no-mixed-spaces-and-tabs */
import $ from 'jquery'
import '@/common/js/jquery.min.js'
import { imgScroll } from '@/common/js/imgscroll.min.js'
import '@/common/js/bootstrap.min.js'
import TimeLine from '@/components/TimeLine.vue'

export default {
  name: 'Home',
  components: {TimeLine},
  data () {
    return {
      sid: '',
      direct: [
        {img: '../../static/images/direct1.png', title: '产品创新/体验设计', des: '产品创新工作坊——实践案例引导产品创新，用户思维驱动产品设计'},
        {img: '../../static/images/direct2.png', title: '团队管理/工程文化', des: '团队管理工作坊——探索实践创新模式下组织发展与团队管理的有效模式'},
        {img: '../../static/images/direct3.png', title: '架构设计/技术战略', des: '架构设计工作坊——用户需求引导的架构设计，架构演进背后的最佳实践'},
        {img: '../../static/images/direct4.png', title: '人工智能/数据科学', des: 'AI&数据工作坊——深入探究数据科学，全景梳理AI典型应用场景'},
        {img: '../../static/images/direct5.png', title: '测试管理/研发效能', des: '测试管理工作坊——测试落地实践与质量保障，工具链建设技术创新实践'}
      ],
      shouhuo_text: [
        {text: '每次参加MPD都是一次快速提升的经历，通过学习别人的经验可以让我们自己的开发少走弯路。', name: 'Jessica', position: '花旗银行项目经理'},
        {text: '今年的MPD引入了视觉引导系统，在听完课后，把视觉引导图拍走，回家可以根据引导图迅速回忆起老师讲的东西', name: 'Lion', position: '中兴通信系统架构师'},
        {text: '参加MPD最大的好处就是能让团队的成员串场听工作范围以外的一些分享和案例，这对培养全面素质的技术管理者很有好处', name: 'Dina', position: 'Hp测试经理'},
        {text: '每年派人参加MPD就是因为可以在这里动手实践一些东西，我觉得这比单纯的技术分享对别人的启发大', name: 'Dacid', position: '一号店产品负责人'}
      ],
      sponsors: [],
      lecturers: [],
      courses: [],
      cases: [],
      casesRenderLength: {pc: 9, mob: 6},
      casesRender: {pc: [], mob: []},
      casesRenderIndex: {pc: [], mob: []},
      casesRenderHistory: [],
      refreshTime: 0.35,
      timeList: {sec: 0, list: []},
      review: [],
      meeting: {time: '', address: ''},
      thisYear: new Date().getFullYear()
    }
  },
  computed: {
    cssVars () {
      return {
        '--refresh-time': this.refreshTime + 's'
      }
    }
  },
  methods: {
    getThumbs: function (img) {
      // item.thumbs?item.thumbs+'?imageView2/1/w/200/h/200/q/75':'../../static/images/def.jpg'
      return img.split('?')[0] + '?imageView2/1/w/200/h/200/q/100'
    },
    changSid: function (id) {
      // console.log("cSid  ",id);
      this.$router.push({path: '/home', name: 'Home', query: {sid: id}})
      // location.reload();
      // this.$router.go(0)
      window.location.reload() // 替代
    },
    toNext: function (n, e) {
      let aid = this.sid
      switch (n) {
        case 'experts':
          this.$router.push({path: '/experts', query: {sid: this.global.area_id}})
          break
        case 'example':
          this.$router.push({path: '/example', query: {sid: this.global.area_id}})
          break
        case 'sponsor':
          this.$router.push({path: '/sponsor', query: {sid: this.global.area_id}})
          break
        case 'order':
          this.$router.push({path: '/order', query: {sid: this.global.area_id}})
          break
        case 'course':
          this.$router.push({path: '/course', name: 'Course', query: {sid: this.global.area_id, id: e}})
          break
        case 'teacher':
          this.$router.push({path: '/teacher', name: 'Teacher', query: {sid: this.global.area_id, id: e}})
          break
        default:
          break
      }
    },
    getSchedule () {
      if (this.global.isReallyNaN(parseInt(this.global.area_id))) {
        this.meeting.time = this.global.config[this.global.area_id].year + '.' + this.global.config[this.global.area_id].starttime + '~' + this.global.config[this.global.area_id].endtime
        // this.meeting.address = this.global.config[this.global.area_id].title
      } else {
        let url_schedule = this.global.url.place + this.global.area_id
        this.$http
          .jsonp(url_schedule)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.status === '200') {
              this.meeting.time = this.global.formatTime(data.data.startTime, 'Y.M.D') + '~' + this.global.formatTime(data.data.endTime, 'D')
              this.meeting.address = data.data.address
              // console.log(this.meeting.time, this.meeting.address);
            }
          })
      }
    },
    getLecturers: function () {
      // 获取专家信息
      var area_id = this.sid
      var url_lecturers = this.global.url.lecturers + area_id
      this.$http
        .jsonp(url_lecturers)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          this.lecturers = []
          if (data.errno && data.errno.toString() === '0') {
            let len = data.data && data.data.length < 6 ? data.data.length : 6
            for (let i = 0; i < len; i++) {
              this.lecturers.push(data.data[i])
              // console.log(this.lecturers);
            }
            // this.lecturers = data.data;
            // console.log(this.lecturers);
          }
        })
    },
    getSponsor: function () {
      // 获取赞助与合作
      var area_id = this.sid
      // var url_sponsor = this.global.url.sponsor + this.global.url.sponsor;
      if (this.global.config[area_id].adId && this.global.config[area_id].adId.length > 0) {
        var url_sponsor = this.global.url.gettype + this.global.config[area_id].adId
        // console.log("url_sponsor ", url_sponsor, ' ', area_id);
        this.$http
          .jsonp(url_sponsor)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.errno && data.errno.toString() === '0') {
              this.sponsors = data.data[0]
              // console.log(this.sponsors);
            }
          })
      }
    },
    getCourse: function () {
      // 获取课程推荐（沙盘工作坊）
      var area_id = this.sid
      var url_course = this.global.url.course + area_id
      // console.log("url_course ", url_course, ' ', area_id);
      this.$http
        .jsonp(url_course)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data.data)
          if (data.errno && data.errno.toString() === '0') {
            this.courses = data.data
          }
        })
    },
    setCasesRender: function (list) {
      let screenWidth = window.innerWidth
      let limit = screenWidth > 767 ? this.casesRenderLength['pc'] : this.casesRenderLength['mob']
      if (list.length > limit) {
        let _randomPC = localStorage.getItem('case_random_pc')
        let _randomMob = localStorage.getItem('case_random_mob')
        let _randomArrPC = (_randomPC && _randomPC.split(',')) || []
        let _randomArrMob = (_randomMob && _randomMob.split(',')) || []
        let _randomArr = {pc: _randomArrPC, mob: _randomArrMob}
        let _name = {pc: 'case_random_pc', mob: 'case_random_mob'}
        this.casesRenderHistory = []
        this.cases = []
        let num = 0 // 随机数
        let renderLength = 0 // 渲染长度
        let randomArrPre = [] // 上一次渲染索引列表
        let randomArrNow = [] // 当前渲染索引列表
        for (let type of ['pc', 'mob']) {
          renderLength = this.casesRenderLength[type]
          randomArrNow = this.casesRender[type]
          randomArrPre = _randomArr[type]
          for (let i = 0; i < renderLength; i++) {
            num = this.global.setRandom(0, list.length - 1)
            if (!num || randomArrNow.includes(num) || randomArrPre.includes(num)) {
              i--
            } else {
              randomArrNow.push(num)
            }
          }
          this.casesRender[type] = randomArrNow
          localStorage.setItem(_name[type], randomArrNow)
        }
        let screenWidth = window.innerWidth
        randomArrNow = screenWidth > 767 ? this.casesRender['pc'] : this.casesRender['mob']
        for (let index of randomArrNow) {
          this.casesRenderHistory.push(index)
          this.cases.push(list[index])
        }
        window.addEventListener('resize', () => {
          if (this.$route.path === '/home') {
            screenWidth = window.innerWidth
            randomArrNow = screenWidth > 767 ? this.casesRender['pc'] : this.casesRender['mob']
            this.casesRenderHistory = []
            this.cases = []
            for (let index of randomArrNow) {
              this.casesRenderHistory.push(index)
              this.cases.push(list[index])
            }
          }
        })
      } else {
        this.cases = [...list]
      }
    },
    refreshCases: function (e) {
      $(e.target).addClass('rotate')
      let screenWidth = window.innerWidth
      let randomArrNow = screenWidth > 767 ? this.casesRender['pc'] : this.casesRender['mob']
      let renderLength = screenWidth > 767 ? this.casesRenderLength['pc'] : this.casesRenderLength['mob']
      // console.log(screenWidth, this.courses, this.casesRenderHistory)
      this.cases = []
      if (this.casesRenderHistory.length === this.courses.length) {
        this.casesRenderHistory = []
        // console.log('------ ', randomArrNow);
        for (let i of randomArrNow) {
          this.casesRenderHistory.push(i)
          this.cases.push(this.courses[i])
        }
      } else {
        for (let i = 0; i < renderLength; i++) {
          // console.log(i, this.casesRenderHistory)
          for (let c in this.courses) {
            if (!this.casesRenderHistory.includes(parseInt(c))) {
              this.casesRenderHistory.push(parseInt(c))
              this.cases.push(this.courses[c])
              break
            }
          }
        }
      }
      setTimeout(() => {
        $(e.target).removeClass('rotate')
      }, this.refreshTime * 1000)
    },
    getReview: function () {
      var area_id = this.sid
      var url_review = this.global.url.review
      this.$http
        .jsonp(url_review)
        .then((data) => {
          return data.json()
        })
        .then((obj) => {
          // console.log('Home getReview ',obj);
          if (obj.errno && obj.errno.toString() === '0') {
            // getReview
            let review = []
            let review_year_keys = Object.keys(obj.data)
            let max_year = 0
            let max_sec = 0
            for (let i = 0; i < review_year_keys.length; i++) {
              max_year = Math.max(max_year, parseInt(review_year_keys[i]))
            }
            let this_time = new Date().getTime()
            let review_flag = []
            let flag = 0
            review_year_keys.map(year => {
              obj.data[year].map(item => {
                if ((item.startTime * 1000 + 2 * 24 * 60 * 60 * 1000) > this_time) {
                  flag ++
                  review_flag.push(item)
                }
              })
            })
            review_flag.sort(this.global.toSortKey('startTime', 1, 'string'))
            // console.log(review_flag);
            review = flag > 0 ? review_flag : []
            // let limit = flag>0 ? flag : 1; // 首页显示即将召开的几届大会
            // let len2 = obj.data[max_year-2].length;
            // let len1 = obj.data[max_year-1].length;
            // let len0 = obj.data[max_year].length;
            // if(len0 >= limit){ // 最近一年超过limit届
            //   for(let i=0;i<limit;i++){
            //     review.push(obj.data[max_year][limit-1-i]);
            //   }
            // } else if((len0+len1) >= limit) { // 取上一年补齐limit届
            //   for(let i=0;i<(limit-len0);i++){
            //     review.push(obj.data[max_year-1][(limit-1-len0)-i]);
            //   }
            //   for(let i=0;i<(limit-review.length);i++){
            //     review.push(obj.data[max_year][(2-review.length)-i]);
            //   }
            // } else { // 取上上年补齐limit届
            //   for(let i=0;i<(limit-(len0+len1));i++){
            //     review.push(obj.data[max_year-2][(limit-1-(len0+len1))-i]);
            //   }
            //   for(let i=0;i<len1;i++){
            //     review.push(obj.data[max_year-1][(len1-1)-i]);
            //   }
            //   for(let i=0;i<len0;i++){
            //     review.push(obj.data[max_year][(len0-1)-i]);
            //   }
            // }
            // console.log("Home this.review：",review);
            this.review = review
            // homeTimeLine
            let time_keys = Object.keys(obj.data)
            let len = 0
            for (let i = 0; i < time_keys.length; i++) {
              len += obj.data[time_keys[i]].length
            }
            this.timeList.sec = len
            // console.log('line ',time_keys,len);
            if (time_keys.length >= 4) {
              for (let i = 0; i < 4; i++) {
                if (i < 3) {
                  this.timeList.list.push({year: '', list: []})
                  this.timeList.list[i].year = time_keys[time_keys.length - 1 - i]
                  len = len - obj.data[this.timeList.list[i].year].length
                  this.timeList.list[i].len = len
                  this.timeList.list[i].list = obj.data[this.timeList.list[i].year].reverse()
                } else {
                  this.timeList.list.push({year: ''})
                  this.timeList.list[i].year = time_keys[time_keys.length - 1 - i]
                  len = len - obj.data[this.timeList.list[i].year].length
                  this.timeList.list[i].len = len
                }
              }
            } else {
              for (let i = 0; i < time_keys.length; i++) {
                this.timeList.list.push({year: '', list: []})
                this.timeList.list[i].year = time_keys[time_keys.length - 1 - i]
                len = len - obj.data[this.timeList.list[i].year].length
                this.timeList.list[i].len = len
                this.timeList.list[i].list = obj.data[this.timeList.list[i].year].reverse()
              }
            }
            // console.log('timeList ',this.timeList);
          }
        })
    }
  },
  created () {
    // 客户证言滚动（class name）
    $(function () {
      imgScroll.rolling({
        name: 'gundong_img',
        width: '373px',
        height: '225px',
        direction: 'left',
        speed: 45,
        addcss: true
      })
    })

    this.sid = this.global.area_id
    if (this.$route.query.sid) {
      this.sid = this.$route.query.sid
    }

    this.getReview()
    this.getSchedule()
    this.getLecturers()
    this.getSponsor()
    this.getCourse()
  },
  mounted () {
    let area_id = this.global.area_id
    console.log('第' + this.global.config[area_id]['jieshu'] + '届MPD' + ' ' + this.global.config[area_id]['title'])
  },
  watch: {
	  '$route' (to, from) { // 监听路由是否变化
		  if (to.query.sid.toString() !== from.query.sid.toString()) {
        this.params = this.$route.query
        // this.loading = true;
        this.getReview()
        this.getSchedule()
        this.getLecturers()
        this.getSponsor()
        this.getCourse()
		  }
    },
    // sid(){}
    courses: {
      handler (_new, _old) {
        if (_new && _new.length > 0) {
          this.setCasesRender(_new)
        }
      },
      immediate: true,
      deep: true
    }
 	}
}
</script>

<style lang="scss">
.page-home {
  .banner.pc {
    .banner_mid {
      height: 620px;
      padding: 0 15px;
      background: url('../../static/images/banner_new.jpg') top center no-repeat;
    }
    .banner_bottom {
      .banner_bottom_con {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
      .col-lg-4 {
        height: auto;
        min-height: 88px;
        div {
          display: flex;
          justify-content: center;
          .banner_p2 {
            width: auto;
            line-height: 1;
            margin: 0;
          }
          .banner_p3 {
            width: 100%;
            max-width: 165px;
            margin-top: 0;
            margin-left: 0;
            padding: 10px 0 8px 0;
            display: grid;
            align-content: space-between;
            span {
              width: 100%;
              height: fit-content;
              display: block;
              font-family: Alibaba PuHuiTi;
              font-size: 16px;
              line-height: 1;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue